import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=0752b70d&scoped=true&"
import script from "./Steps.vue?vue&type=script&lang=js&"
export * from "./Steps.vue?vue&type=script&lang=js&"
import style0 from "./Steps.vue?vue&type=style&index=0&id=0752b70d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0752b70d",
  null
  
)

export default component.exports